import { render, staticRenderFns } from "./OrticMonthpicker.vue?vue&type=template&id=2d382a2d&"
import script from "./OrticMonthpicker.vue?vue&type=script&lang=js&"
export * from "./OrticMonthpicker.vue?vue&type=script&lang=js&"
import style0 from "./OrticMonthpicker.vue?vue&type=style&index=0&id=2d382a2d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports